import React, { ReactNode } from 'react';
import './NocmetricCard.css';
import { Icon,IconWithTooltip } from '../../../globalUtils/globalIcons';
import { useEffectOnce } from '../../../globalUtils/globalHooks';
import { useAppDispatch, useAppSelector } from '../../../rmsReduxStore/rmsReduxHooks';
import { getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports';
import { fetchAcChargerVisibleIdReferenceData } from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';
import { setAcFilterData } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import { setRedirectedStateForAcChargerFilters } from '../../rmsReduxStore/acChargersRedux/acChargerCreators';
import { setChargerIdsForRedirection } from '../../rmsReduxStore/acNocDashboardRedux/acNocDashboardCreator';
import { setRedirectedStateForAcAlarmFilters } from '../../rmsReduxStore/acAlarmsRedux/acAlarmCreators';

interface NocMetricCardProps {
  icon?: ReactNode;
  heading: string;
  value?: number | string;
  unit?: string;
  subText?: ReactNode;
  sublineChart?: ReactNode;
  donutChart?: ReactNode;
  lineChart?: ReactNode;
  legend?: ReactNode;
  color?: string;
  cardType?: string;
  allChargerIds?: string[];
  infoTooltipText?:string;
}

const AcNocmetricCard: React.FC<NocMetricCardProps> = ({
  color,
  heading,
  value,
  unit,
  subText,
  donutChart,
  lineChart,
  legend,
  sublineChart,
  cardType,
  allChargerIds,
  infoTooltipText
}) => {
const dispatch = useAppDispatch();
const getDateBeforeDays = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  date.setUTCHours(18, 30, 0, 0);
  return date.toISOString();
};

const alarmSetTime = ['2024-07-01T18:30:00.000Z',getDateBeforeDays(6)];

  const { chargerVisibleIdReferenceData } = useAppSelector(getAcReferenceDataReducer);
  
  useEffectOnce(()=>{
    dispatch(fetchAcChargerVisibleIdReferenceData()) 
  })

  const isClickable =(cardType === 'charger' || cardType === 'chronic-alarms' || cardType === 'live-sessions'  ||  cardType === 'failed-transactions') && Number(value) !== 0;
  return (
    <div className={`noc-card-${color}`}>
      <div className='noc-icon-info'>
        <div className={`noc-icon-${color}`} >
          <Icon iconClassName={`noc-dashboard-metric-card-${cardType}-icon`}/>
        </div>
        <div className="noc-info">
          <div className='noc-heading'>
          <p className={`noc-subtext-${color}`}>{heading}</p>
           <IconWithTooltip iconClassName="info-icon" toolTipText={infoTooltipText} containerClassName={'noc-info-tooltip'} />
           </div>
          <div className="noc-value">
            <span
              className="noc-stats-value"
              onClick={async () => {
                if (!isClickable) return;
                if (cardType === 'charger') {
                  await setAcFilterData('','','acchargers','CLEAR',false,true,false)(dispatch);
                  setRedirectedStateForAcChargerFilters(true, null, null, null)(dispatch)
                  dispatch(setChargerIdsForRedirection(allChargerIds))
                  window.open('/ac/manage-chargers?redirectedFrom=nocDashboard', '_blank');
                }
                else if (cardType === 'chronic-alarms') {
                  setRedirectedStateForAcAlarmFilters(true, 'Critical', '', '', '', '', alarmSetTime, allChargerIds)(dispatch)
                    .then((res) => {
                      if (res === 'Action dispatched successfully') {
                        window.open('/ac/alarms?redirectedFrom=nocDashboard','_blank')
                      }
                    })
                    .catch((error) => {
                      console.error('Error dispatching action:', error); 
                    });
                }
                else if(cardType === 'live-sessions'){
                const latestSelectedChargers = chargerVisibleIdReferenceData?.filter(item=>allChargerIds?.includes(item?.id));
                const res = await setAcFilterData(latestSelectedChargers,'chargerId', 'acStatusHistoryReport', 'SET', false)(dispatch);
                if(res?.message === 'Action dispatched successfully') {
                  window.open('/ac/status-history?redirectedFrom=nocDashboard&sessionType=active','_blank')
                }
              
                
                }
                else if(cardType === 'failed-transactions'){
                const latestSelectedChargers = chargerVisibleIdReferenceData?.filter(item=>allChargerIds?.includes(item?.id));
                const res = await setAcFilterData(latestSelectedChargers,'chargerId', 'acStatusHistoryReport', 'SET', false)(dispatch);
                 if(res?.message === 'Action dispatched successfully') {
                  window.open('/ac/status-history?redirectedFrom=nocDashboard&sessionType=failed','_blank')
                }
                
                }
              }}
              style={{
                cursor: isClickable ? 'pointer' : 'default'
              }}
            >
              {value}
            </span>

            {unit && <p className="noc-subtext" >{unit}</p>}
            {subText && <p className="noc-subtext" >{subText}</p>}
            {sublineChart && <div className="noc-lineChart">{sublineChart}</div>}
          </div>
        </div>
      </div>
      <div className='noc-stats'>
        {lineChart && <div className="noc-right">
          <div className="noc-lineChart">{lineChart}</div>
        </div>}
        {donutChart &&
          <div className='noc-donut ' >
            {donutChart}
            {legend && <div className="noc-legend">{legend}</div>}
          </div>}
      </div>
    </div>

  );
};

export default AcNocmetricCard;

